module.exports = __webpack_public_path__ + "fonts/tt_sushkof_medium.ad969d1.ttf";